<template>
	<el-radio-group v-model="selectedValue" @change="handleChange">
		<el-radio v-for="(option, index) in sortedOptions" :key="option.optionName" :label="index">
			<ellipsis-two-line-tooltip class="option-text-ellipsis" :text="option.optionName" />
		</el-radio>
	</el-radio-group>
</template>

<script setup>
import { ref, computed } from 'vue';
import EllipsisTwoLineTooltip from '@rebuild/components/custom-fields/EllipsisTwoLineTooltip.vue';

const props = defineProps({
	field: {
		type: Object,
		required: true
	}
});

const emits = defineEmits(['update']);

const selectedValue = ref(props.field?.dynamicFieldValue || '');

const handleChange = val => {
	emits('update', val !== '' && val !== undefined ? String(val) : '');
};

const sortedOptions = computed(() => {
	const options = props.field?.conditionOptionVOList || [];
	return [...options].sort((a, b) => (a.sort || 0) - (b.sort || 0));
});
</script>

<style lang="less" scoped>
.option-text-ellipsis {
	max-width: 280px;
	vertical-align: text-top;
}
</style>
